/* 1000M-HOME-HYPER | D-02 | START | 2026-10-06 | Editor first-add registry. */
const mmhModules = new Map();
const mmhAllowed = new Set(['mmh-hero-slideshow-horizontal.js', 'mmh-promotional-collections.js']);
function mmhLoad(root) {
  const nodes = [...root.querySelectorAll('[data-mmh-module]')];
  if (root.matches?.('[data-mmh-module]')) nodes.unshift(root);
  for (const node of nodes) {
    const url = new URL(node.dataset.mmhModule, document.baseURI);
    const filename = url.pathname.split('/').pop();
    if (!mmhAllowed.has(filename) || mmhModules.has(url.href)) continue;
    mmhModules.set(url.href, import(url.href).catch(error => {
      mmhModules.delete(url.href);
      console.warn('1000 Marcas: componente do editor indisponível.', error);
    }));
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => mmhLoad(document), { once: true });
} else mmhLoad(document);
document.addEventListener('shopify:section:load', event => mmhLoad(event.target));
/* 1000M-HOME-HYPER | D-02 | END */
